<template>
    <section class="inner-header">
        <div class="container">
            <div class="row">
                <div class="col-md-12 sec-title colored text-center">
                    <h2>{{title}}</h2>
                    <ul class="breadcumb">
                        <!-- <li><span>About us</span></li> -->
                    </ul>
                    <span class="decor"><span class="inner"></span></span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
	export default {
		name: "page-header",
        props: ['title']
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/PageTitle.vue